"use client";

import { useEffect } from "react";

function parseConsentCookie(cookieValue: string) {
  const categories = cookieValue.split(",").map((x) => x.trim());

  return {
    essential: true,
    functional: categories.includes("functional"),
    analytics: categories.includes("analytics"),
    marketing: categories.includes("marketing"),
  };
}

export default function ConsentDataLayerInit() {
  useEffect(() => {
    // Read consent cookie
    const match = document.cookie.match(/cookie_consent=([^;]+)/);
    if (!match) return;

    const consentValue = decodeURIComponent(match[1]);
    const consentState = parseConsentCookie(consentValue);

    // Push init event into dataLayer
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: "cookie_consent_init",
      cookie_consent: consentState,
    });
  }, []);

  return null;
}
